import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ChipButton',
  props: {
    active: { type: Boolean },
    noBorders: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})